<template>
  <div class="fault-devicetree">
    <h2 class="top-title">
      <Icon @click="goBack" type="md-arrow-back" />
      <span>设备树</span>
    </h2>
    <Card dis-hover>
      <div class="box">
        <div class="left-tree">
          <Input
            v-model="treeForm.tenantName"
            @on-enter="changeSearch"
            prefix="ios-search"
            placeholder="搜索"
          />
          <Cstree :init="init" v-if="treeLists" :treeLists="treeLists" />
        </div>
      </div>
    </Card>
  </div>
</template>
<script>
import api from "@/api";
import Cstree from "@/components/c-stree/index";
import { equipmentTree } from "@/api/cstree";
export default {
  components: {
    Cstree,
  },
  data() {
    return {
      treeForm: {
        tenantName: null,
      },
      treeLists: [],
    };
  },
  created() {
    this.$store.state.spinShow = false;
    this.init();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async init(name = "all") {
      let { data } = await equipmentTree(name);
      this.treeLists = data;
    },
    changeSearch(value) {
      if (this.treeForm.tenantName == "") {
        this.init();
      } else {
        this.init(this.treeForm.tenantName);
      }
    },
  },
};
</script>

<style lang="less" >
.fault-devicetree {
  .box {
    min-height: 80vh;
  }
  .left-tree {
    width: 400px;

    min-height: 460px;
    // overflow: auto;
    padding-right: 20px;
    box-sizing: initial;

    .ivu-input-wrapper {
      .ivu-input {
        border: none;
        border-bottom: 1px solid #dcdee2;
        border-radius: 0;
        box-shadow: none !important;
      }
    }

    .ivu-tabs-nav-wrap {
      .ivu-tabs-nav {
        .ivu-tabs-tab {
          padding: 16px;
        }
      }
    }
  }
}
</style>